export default [
  { name: 'Россия', iso2: 'ru', dialCode: '7', priority: 0, areaCodes: null },
  { name: 'Украина', iso2: 'ua', dialCode: '380', priority: 0, areaCodes: null },
  { name: 'Беларусь', iso2: 'by', dialCode: '375', priority: 0, areaCodes: null },
  { name: 'Казахстан', iso2: 'kz', dialCode: '7', priority: 1, areaCodes: null },
  { name: 'Австралия', iso2: 'au', dialCode: '61', priority: 0, areaCodes: null },
  { name: 'Австрия', iso2: 'at', dialCode: '43', priority: 0, areaCodes: null },
  { name: 'Азербайджан', iso2: 'az', dialCode: '994', priority: 0, areaCodes: null },
  { name: 'Аландские острова', iso2: 'ax', dialCode: '358', priority: 1, areaCodes: null },
  { name: 'Албания', iso2: 'al', dialCode: '355', priority: 0, areaCodes: null },
  { name: 'Алжир', iso2: 'dz', dialCode: '213', priority: 0, areaCodes: null },
  { name: 'Американские Виргинские острова', iso2: 'vi', dialCode: '1340', priority: 0, areaCodes: null },
  { name: 'Американское Самоа', iso2: 'as', dialCode: '1684', priority: 0, areaCodes: null },
  { name: 'Ангилья', iso2: 'ai', dialCode: '1264', priority: 0, areaCodes: null },
  { name: 'Ангола', iso2: 'ao', dialCode: '244', priority: 0, areaCodes: null },
  { name: 'Андорра', iso2: 'ad', dialCode: '376', priority: 0, areaCodes: null },
  { name: 'Антигуа и Барбуда', iso2: 'ag', dialCode: '1268', priority: 0, areaCodes: null },
  { name: 'Аргентина', iso2: 'ar', dialCode: '54', priority: 0, areaCodes: null },
  { name: 'Армения', iso2: 'am', dialCode: '374', priority: 0, areaCodes: null },
  { name: 'Аруба', iso2: 'aw', dialCode: '297', priority: 0, areaCodes: null },
  { name: 'Афганистан', iso2: 'af', dialCode: '93', priority: 0, areaCodes: null },
  { name: 'Багамские острова', iso2: 'bs', dialCode: '1242', priority: 0, areaCodes: null },
  { name: 'Бангладеш', iso2: 'bd', dialCode: '880', priority: 0, areaCodes: null },
  { name: 'Банин', iso2: 'bj', dialCode: '229', priority: 0, areaCodes: null },
  { name: 'Барбадос', iso2: 'bb', dialCode: '1246', priority: 0, areaCodes: null },
  { name: 'Бахрейн', iso2: 'bh', dialCode: '973', priority: 0, areaCodes: null },
  { name: 'Белиз', iso2: 'bz', dialCode: '501', priority: 0, areaCodes: null },
  { name: 'Бельгия', iso2: 'be', dialCode: '32', priority: 0, areaCodes: null },
  { name: 'Бермудские острова', iso2: 'bm', dialCode: '1441', priority: 0, areaCodes: null },
  { name: 'Болгария', iso2: 'bg', dialCode: '359', priority: 0, areaCodes: null },
  { name: 'Боливия', iso2: 'bo', dialCode: '591', priority: 0, areaCodes: null },
  { name: 'Босния и Герцеговина', iso2: 'ba', dialCode: '387', priority: 0, areaCodes: null },
  { name: 'Ботсвана', iso2: 'bw', dialCode: '267', priority: 0, areaCodes: null },
  { name: 'Бразилия', iso2: 'br', dialCode: '55', priority: 0, areaCodes: null },
  { name: 'Британская территория в Индийском океане', iso2: 'io', dialCode: '246', priority: 0, areaCodes: null },
  { name: 'Британские Виргинские острова', iso2: 'vg', dialCode: '1284', priority: 0, areaCodes: null },
  { name: 'Бруней', iso2: 'bn', dialCode: '673', priority: 0, areaCodes: null },
  { name: 'Буркина-Фасо', iso2: 'bf', dialCode: '226', priority: 0, areaCodes: null },
  { name: 'Бурунди', iso2: 'bi', dialCode: '257', priority: 0, areaCodes: null },
  { name: 'Бутан', iso2: 'bt', dialCode: '975', priority: 0, areaCodes: null },
  { name: 'Вануату', iso2: 'vu', dialCode: '678', priority: 0, areaCodes: null },
  { name: 'Ватикан', iso2: 'va', dialCode: '39', priority: 1, areaCodes: null },
  { name: 'Великобритания', iso2: 'gb', dialCode: '44', priority: 0, areaCodes: null },
  { name: 'Венгрия', iso2: 'hu', dialCode: '36', priority: 0, areaCodes: null },
  { name: 'Венесуэла', iso2: 've', dialCode: '58', priority: 0, areaCodes: null },
  { name: 'Восточный Тимор', iso2: 'tl', dialCode: '670', priority: 0, areaCodes: null },
  { name: 'Вьетнам', iso2: 'vn', dialCode: '84', priority: 0, areaCodes: null },
  { name: 'Габон', iso2: 'ga', dialCode: '241', priority: 0, areaCodes: null },
  { name: 'Гаити', iso2: 'ht', dialCode: '509', priority: 0, areaCodes: null },
  { name: 'Гайана', iso2: 'gy', dialCode: '592', priority: 0, areaCodes: null },
  { name: 'Гамбия', iso2: 'gm', dialCode: '220', priority: 0, areaCodes: null },
  { name: 'Гана', iso2: 'gh', dialCode: '233', priority: 0, areaCodes: null },
  { name: 'Гваделупа', iso2: 'gp', dialCode: '590', priority: 0, areaCodes: null },
  { name: 'Гватемала', iso2: 'gt', dialCode: '502', priority: 0, areaCodes: null },
  { name: 'Гвинея', iso2: 'gn', dialCode: '224', priority: 0, areaCodes: null },
  { name: 'Гвинея-Биссау', iso2: 'gw', dialCode: '245', priority: 0, areaCodes: null },
  { name: 'Германия', iso2: 'de', dialCode: '49', priority: 0, areaCodes: null },
  { name: 'Гернси', iso2: 'gg', dialCode: '44', priority: 1, areaCodes: null },
  { name: 'Гибралтар', iso2: 'gi', dialCode: '350', priority: 0, areaCodes: null },
  { name: 'Гондурас', iso2: 'hn', dialCode: '504', priority: 0, areaCodes: null },
  { name: 'Гонконг', iso2: 'hk', dialCode: '852', priority: 0, areaCodes: null },
  { name: 'Гренада', iso2: 'gd', dialCode: '1473', priority: 0, areaCodes: null },
  { name: 'Гренландия', iso2: 'gl', dialCode: '299', priority: 0, areaCodes: null },
  { name: 'Греция', iso2: 'gr', dialCode: '30', priority: 0, areaCodes: null },
  { name: 'Грузия', iso2: 'ge', dialCode: '995', priority: 0, areaCodes: null },
  { name: 'Гуам', iso2: 'gu', dialCode: '1671', priority: 0, areaCodes: null },
  { name: 'Дания', iso2: 'dk', dialCode: '45', priority: 0, areaCodes: null },
  { name: 'Демократическая Республика Конго', iso2: 'cd', dialCode: '243', priority: 0, areaCodes: null },
  { name: 'Джернси', iso2: 'je', dialCode: '44', priority: 3, areaCodes: null },
  { name: 'Джибути', iso2: 'dj', dialCode: '253', priority: 0, areaCodes: null },
  { name: 'Доминика', iso2: 'dm', dialCode: '1767', priority: 0, areaCodes: null },
  { name: 'Доминиканская республика', iso2: 'do', dialCode: '1', priority: 2, areaCodes: ['809', '829', '849'] },
  { name: 'Египет', iso2: 'eg', dialCode: '20', priority: 0, areaCodes: null },
  { name: 'Замбия', iso2: 'zm', dialCode: '260', priority: 0, areaCodes: null },
  { name: 'Западная Сахара', iso2: 'eh', dialCode: '212', priority: 1, areaCodes: null },
  { name: 'Зимбабве', iso2: 'zw', dialCode: '263', priority: 0, areaCodes: null },
  { name: 'Израиль', iso2: 'il', dialCode: '972', priority: 0, areaCodes: null },
  { name: 'Индия', iso2: 'in', dialCode: '91', priority: 0, areaCodes: null },
  { name: 'Индонезия', iso2: 'id', dialCode: '62', priority: 0, areaCodes: null },
  { name: 'Иордания', iso2: 'jo', dialCode: '962', priority: 0, areaCodes: null },
  { name: 'Ирак', iso2: 'iq', dialCode: '964', priority: 0, areaCodes: null },
  { name: 'Иран', iso2: 'ir', dialCode: '98', priority: 0, areaCodes: null },
  { name: 'Ирландия', iso2: 'ie', dialCode: '353', priority: 0, areaCodes: null },
  { name: 'Исландия', iso2: 'is', dialCode: '354', priority: 0, areaCodes: null },
  { name: 'Испания', iso2: 'es', dialCode: '34', priority: 0, areaCodes: null },
  { name: 'Италия', iso2: 'it', dialCode: '39', priority: 0, areaCodes: null },
  { name: 'Йемен', iso2: 'ye', dialCode: '967', priority: 0, areaCodes: null },
  { name: 'КНДР', iso2: 'kp', dialCode: '850', priority: 0, areaCodes: null },
  { name: 'КНР', iso2: 'cn', dialCode: '86', priority: 0, areaCodes: null },
  { name: 'Кабо-Верде', iso2: 'cv', dialCode: '238', priority: 0, areaCodes: null },
  { name: 'Каймановы острова', iso2: 'ky', dialCode: '1345', priority: 0, areaCodes: null },
  { name: 'Камбоджа', iso2: 'kh', dialCode: '855', priority: 0, areaCodes: null },
  { name: 'Камерун', iso2: 'cm', dialCode: '237', priority: 0, areaCodes: null },
  {
    name: 'Канада',
    iso2: 'ca',
    dialCode: '1',
    priority: 1,
    areaCodes: [
      '204',
      '226',
      '236',
      '249',
      '250',
      '289',
      '306',
      '343',
      '365',
      '387',
      '403',
      '416',
      '418',
      '431',
      '437',
      '438',
      '450',
      '506',
      '514',
      '519',
      '548',
      '579',
      '581',
      '587',
      '604',
      '613',
      '639',
      '647',
      '672',
      '705',
      '709',
      '742',
      '778',
      '780',
      '782',
      '807',
      '819',
      '825',
      '867',
      '873',
      '902',
      '905'
    ]
  },
  { name: 'Катар', iso2: 'qa', dialCode: '974', priority: 0, areaCodes: null },
  { name: 'Кения', iso2: 'ke', dialCode: '254', priority: 0, areaCodes: null },
  { name: 'Кипр', iso2: 'cy', dialCode: '357', priority: 0, areaCodes: null },
  { name: 'Киргизия', iso2: 'kg', dialCode: '996', priority: 0, areaCodes: null },
  { name: 'Кирибати', iso2: 'ki', dialCode: '686', priority: 0, areaCodes: null },
  { name: 'Кокосовые острова', iso2: 'cc', dialCode: '61', priority: 1, areaCodes: null },
  { name: 'Колумбия', iso2: 'co', dialCode: '57', priority: 0, areaCodes: null },
  { name: 'Коморские острова', iso2: 'km', dialCode: '269', priority: 0, areaCodes: null },
  { name: 'Коста-Рика', iso2: 'cr', dialCode: '506', priority: 0, areaCodes: null },
  { name: 'Кот д’Ивуар', iso2: 'ci', dialCode: '225', priority: 0, areaCodes: null },
  { name: 'Куба', iso2: 'cu', dialCode: '53', priority: 0, areaCodes: null },
  { name: 'Кувейт', iso2: 'kw', dialCode: '965', priority: 0, areaCodes: null },
  { name: 'Кюрасао', iso2: 'cw', dialCode: '599', priority: 0, areaCodes: null },
  { name: 'Лаос', iso2: 'la', dialCode: '856', priority: 0, areaCodes: null },
  { name: 'Латвия', iso2: 'lv', dialCode: '371', priority: 0, areaCodes: null },
  { name: 'Лесото', iso2: 'ls', dialCode: '266', priority: 0, areaCodes: null },
  { name: 'Либерия', iso2: 'lr', dialCode: '231', priority: 0, areaCodes: null },
  { name: 'Ливан', iso2: 'lb', dialCode: '961', priority: 0, areaCodes: null },
  { name: 'Ливия', iso2: 'ly', dialCode: '218', priority: 0, areaCodes: null },
  { name: 'Литва', iso2: 'lt', dialCode: '370', priority: 0, areaCodes: null },
  { name: 'Лихтенштейн', iso2: 'li', dialCode: '423', priority: 0, areaCodes: null },
  { name: 'Люксембург', iso2: 'lu', dialCode: '352', priority: 0, areaCodes: null },
  { name: 'Маврикий', iso2: 'mu', dialCode: '230', priority: 0, areaCodes: null },
  { name: 'Мавритания', iso2: 'mr', dialCode: '222', priority: 0, areaCodes: null },
  { name: 'Мадагаскар', iso2: 'mg', dialCode: '261', priority: 0, areaCodes: null },
  { name: 'Майотта', iso2: 'yt', dialCode: '262', priority: 1, areaCodes: null },
  { name: 'Макао', iso2: 'mo', dialCode: '853', priority: 0, areaCodes: null },
  { name: 'Македония', iso2: 'mk', dialCode: '389', priority: 0, areaCodes: null },
  { name: 'Малави', iso2: 'mw', dialCode: '265', priority: 0, areaCodes: null },
  { name: 'Малайзия', iso2: 'my', dialCode: '60', priority: 0, areaCodes: null },
  { name: 'Мали', iso2: 'ml', dialCode: '223', priority: 0, areaCodes: null },
  { name: 'Мальдивы', iso2: 'mv', dialCode: '960', priority: 0, areaCodes: null },
  { name: 'Мальта', iso2: 'mt', dialCode: '356', priority: 0, areaCodes: null },
  { name: 'Марокко', iso2: 'ma', dialCode: '212', priority: 0, areaCodes: null },
  { name: 'Мартиника', iso2: 'mq', dialCode: '596', priority: 0, areaCodes: null },
  { name: 'Маршалловы острова', iso2: 'mh', dialCode: '692', priority: 0, areaCodes: null },
  { name: 'Мексика', iso2: 'mx', dialCode: '52', priority: 0, areaCodes: null },
  { name: 'Микронезия', iso2: 'fm', dialCode: '691', priority: 0, areaCodes: null },
  { name: 'Мозамбик', iso2: 'mz', dialCode: '258', priority: 0, areaCodes: null },
  { name: 'Молдавия', iso2: 'md', dialCode: '373', priority: 0, areaCodes: null },
  { name: 'Монако', iso2: 'mc', dialCode: '377', priority: 0, areaCodes: null },
  { name: 'Монголия', iso2: 'mn', dialCode: '976', priority: 0, areaCodes: null },
  { name: 'Монтсеррат', iso2: 'ms', dialCode: '1664', priority: 0, areaCodes: null },
  { name: 'Мьянма', iso2: 'mm', dialCode: '95', priority: 0, areaCodes: null },
  { name: 'Намибия', iso2: 'na', dialCode: '264', priority: 0, areaCodes: null },
  { name: 'Науру', iso2: 'nr', dialCode: '674', priority: 0, areaCodes: null },
  { name: 'Непал', iso2: 'np', dialCode: '977', priority: 0, areaCodes: null },
  { name: 'Нигер', iso2: 'ne', dialCode: '227', priority: 0, areaCodes: null },
  { name: 'Нигерия', iso2: 'ng', dialCode: '234', priority: 0, areaCodes: null },
  { name: 'Нидерландские Антильские острова', iso2: 'bq', dialCode: '599', priority: 1, areaCodes: null },
  { name: 'Нидерланды', iso2: 'nl', dialCode: '31', priority: 0, areaCodes: null },
  { name: 'Никарагуа', iso2: 'ni', dialCode: '505', priority: 0, areaCodes: null },
  { name: 'Ниуэ', iso2: 'nu', dialCode: '683', priority: 0, areaCodes: null },
  { name: 'Новая Зеландия', iso2: 'nz', dialCode: '64', priority: 0, areaCodes: null },
  { name: 'Новая Каледония', iso2: 'nc', dialCode: '687', priority: 0, areaCodes: null },
  { name: 'Норвегия', iso2: 'no', dialCode: '47', priority: 0, areaCodes: null },
  { name: 'ОАЭ', iso2: 'ae', dialCode: '971', priority: 0, areaCodes: null },
  { name: 'Оман', iso2: 'om', dialCode: '968', priority: 0, areaCodes: null },
  { name: 'Остров Мэн', iso2: 'im', dialCode: '44', priority: 2, areaCodes: null },
  { name: 'Остров Норфолк', iso2: 'nf', dialCode: '672', priority: 0, areaCodes: null },
  { name: 'Остров Рождества', iso2: 'cx', dialCode: '61', priority: 2, areaCodes: null },
  { name: 'Остров Святой Елены', iso2: 'sh', dialCode: '290', priority: 0, areaCodes: null },
  { name: 'Острова Кука', iso2: 'ck', dialCode: '682', priority: 0, areaCodes: null },
  { name: 'Пакистан', iso2: 'pk', dialCode: '92', priority: 0, areaCodes: null },
  { name: 'Палау', iso2: 'pw', dialCode: '680', priority: 0, areaCodes: null },
  { name: 'Палестинские территории', iso2: 'ps', dialCode: '970', priority: 0, areaCodes: null },
  { name: 'Панама', iso2: 'pa', dialCode: '507', priority: 0, areaCodes: null },
  { name: 'Папуа — Новая Гвинея', iso2: 'pg', dialCode: '675', priority: 0, areaCodes: null },
  { name: 'Парагвай', iso2: 'py', dialCode: '595', priority: 0, areaCodes: null },
  { name: 'Перу', iso2: 'pe', dialCode: '51', priority: 0, areaCodes: null },
  { name: 'Польша', iso2: 'pl', dialCode: '48', priority: 0, areaCodes: null },
  { name: 'Португалия', iso2: 'pt', dialCode: '351', priority: 0, areaCodes: null },
  { name: 'Пуэрто-Рико', iso2: 'pr', dialCode: '1', priority: 3, areaCodes: ['787', '939'] },
  { name: 'Республика Конго', iso2: 'cg', dialCode: '242', priority: 0, areaCodes: null },
  { name: 'Республика Корея', iso2: 'kr', dialCode: '82', priority: 0, areaCodes: null },
  { name: 'Реюньон', iso2: 're', dialCode: '262', priority: 0, areaCodes: null },
  { name: 'Руанда', iso2: 'rw', dialCode: '250', priority: 0, areaCodes: null },
  { name: 'Румыния', iso2: 'ro', dialCode: '40', priority: 0, areaCodes: null },
  { name: 'Сальвадор', iso2: 'sv', dialCode: '503', priority: 0, areaCodes: null },
  { name: 'Самоа', iso2: 'ws', dialCode: '685', priority: 0, areaCodes: null },
  { name: 'Сан-Марино', iso2: 'sm', dialCode: '378', priority: 0, areaCodes: null },
  { name: 'Сан-Томе и Принсипи', iso2: 'st', dialCode: '239', priority: 0, areaCodes: null },
  { name: 'Саудовская Аравия', iso2: 'sa', dialCode: '966', priority: 0, areaCodes: null },
  { name: 'Северные Марианские Острова', iso2: 'mp', dialCode: '1670', priority: 0, areaCodes: null },
  { name: 'Сейшельские острова', iso2: 'sc', dialCode: '248', priority: 0, areaCodes: null },
  { name: 'Сен-Бартелеми', iso2: 'bl', dialCode: '590', priority: 1, areaCodes: null },
  { name: 'Сен-Мартен', iso2: 'mf', dialCode: '590', priority: 2, areaCodes: null },
  { name: 'Сен-Пьер и Микелон', iso2: 'pm', dialCode: '508', priority: 0, areaCodes: null },
  { name: 'Сенегал', iso2: 'sn', dialCode: '221', priority: 0, areaCodes: null },
  { name: 'Сент-Винсент и Гренадины', iso2: 'vc', dialCode: '1784', priority: 0, areaCodes: null },
  { name: 'Сент-Китс и Невис', iso2: 'kn', dialCode: '1869', priority: 0, areaCodes: null },
  { name: 'Сент-Люсия', iso2: 'lc', dialCode: '1758', priority: 0, areaCodes: null },
  { name: 'Сербия', iso2: 'rs', dialCode: '381', priority: 0, areaCodes: null },
  { name: 'Сингапур', iso2: 'sg', dialCode: '65', priority: 0, areaCodes: null },
  { name: 'Синт-Мартен', iso2: 'sx', dialCode: '1721', priority: 0, areaCodes: null },
  { name: 'Сирия', iso2: 'sy', dialCode: '963', priority: 0, areaCodes: null },
  { name: 'Словакия', iso2: 'sk', dialCode: '421', priority: 0, areaCodes: null },
  { name: 'Словения', iso2: 'si', dialCode: '386', priority: 0, areaCodes: null },
  { name: 'Соломоновы острова', iso2: 'sb', dialCode: '677', priority: 0, areaCodes: null },
  { name: 'Сомали', iso2: 'so', dialCode: '252', priority: 0, areaCodes: null },
  { name: 'Судан', iso2: 'sd', dialCode: '249', priority: 0, areaCodes: null },
  { name: 'Суринам', iso2: 'sr', dialCode: '597', priority: 0, areaCodes: null },
  { name: 'США', iso2: 'us', dialCode: '1', priority: 0, areaCodes: null },
  { name: 'Сьерра-Леоне', iso2: 'sl', dialCode: '232', priority: 0, areaCodes: null },
  { name: 'Таджикистан', iso2: 'tj', dialCode: '992', priority: 0, areaCodes: null },
  { name: 'Таиланд', iso2: 'th', dialCode: '66', priority: 0, areaCodes: null },
  { name: 'Тайвань', iso2: 'tw', dialCode: '886', priority: 0, areaCodes: null },
  { name: 'Танзания', iso2: 'tz', dialCode: '255', priority: 0, areaCodes: null },
  { name: 'Теркс и Кайкос', iso2: 'tc', dialCode: '1649', priority: 0, areaCodes: null },
  { name: 'Того', iso2: 'tg', dialCode: '228', priority: 0, areaCodes: null },
  { name: 'Токелау', iso2: 'tk', dialCode: '690', priority: 0, areaCodes: null },
  { name: 'Тонга', iso2: 'to', dialCode: '676', priority: 0, areaCodes: null },
  { name: 'Тринидад и Тобаго', iso2: 'tt', dialCode: '1868', priority: 0, areaCodes: null },
  { name: 'Тувалу', iso2: 'tv', dialCode: '688', priority: 0, areaCodes: null },
  { name: 'Тунис', iso2: 'tn', dialCode: '216', priority: 0, areaCodes: null },
  { name: 'Туркмения', iso2: 'tm', dialCode: '993', priority: 0, areaCodes: null },
  { name: 'Турция', iso2: 'tr', dialCode: '90', priority: 0, areaCodes: null },
  { name: 'Уганда', iso2: 'ug', dialCode: '256', priority: 0, areaCodes: null },
  { name: 'Узбекистан', iso2: 'uz', dialCode: '998', priority: 0, areaCodes: null },
  { name: 'Уоллис и Футуна', iso2: 'wf', dialCode: '681', priority: 0, areaCodes: null },
  { name: 'Уругвай', iso2: 'uy', dialCode: '598', priority: 0, areaCodes: null },
  { name: 'Фарерские острова', iso2: 'fo', dialCode: '298', priority: 0, areaCodes: null },
  { name: 'Фиджи', iso2: 'fj', dialCode: '679', priority: 0, areaCodes: null },
  { name: 'Филиппины', iso2: 'ph', dialCode: '63', priority: 0, areaCodes: null },
  { name: 'Финляндия', iso2: 'fi', dialCode: '358', priority: 0, areaCodes: null },
  { name: 'Фолклендские острова', iso2: 'fk', dialCode: '500', priority: 0, areaCodes: null },
  { name: 'Франция', iso2: 'fr', dialCode: '33', priority: 0, areaCodes: null },
  { name: 'Французская Гвиана', iso2: 'gf', dialCode: '594', priority: 0, areaCodes: null },
  { name: 'Французская Полинезия', iso2: 'pf', dialCode: '689', priority: 0, areaCodes: null },
  { name: 'Хорватия', iso2: 'hr', dialCode: '385', priority: 0, areaCodes: null },
  { name: 'ЦАР', iso2: 'cf', dialCode: '236', priority: 0, areaCodes: null },
  { name: 'Чад', iso2: 'td', dialCode: '235', priority: 0, areaCodes: null },
  { name: 'Черногория', iso2: 'me', dialCode: '382', priority: 0, areaCodes: null },
  { name: 'Чехия', iso2: 'cz', dialCode: '420', priority: 0, areaCodes: null },
  { name: 'Чили', iso2: 'cl', dialCode: '56', priority: 0, areaCodes: null },
  { name: 'Швейцария', iso2: 'ch', dialCode: '41', priority: 0, areaCodes: null },
  { name: 'Швеция', iso2: 'se', dialCode: '46', priority: 0, areaCodes: null },
  { name: 'Шпицберген и Ян-Майен', iso2: 'sj', dialCode: '47', priority: 1, areaCodes: null },
  { name: 'Шри-Ланка', iso2: 'lk', dialCode: '94', priority: 0, areaCodes: null },
  { name: 'Эквадор', iso2: 'ec', dialCode: '593', priority: 0, areaCodes: null },
  { name: 'Экваториальная Гвинея', iso2: 'gq', dialCode: '240', priority: 0, areaCodes: null },
  { name: 'Эритрея', iso2: 'er', dialCode: '291', priority: 0, areaCodes: null },
  { name: 'Эсватини', iso2: 'sz', dialCode: '268', priority: 0, areaCodes: null },
  { name: 'Эстония', iso2: 'ee', dialCode: '372', priority: 0, areaCodes: null },
  { name: 'Эфиопия', iso2: 'et', dialCode: '251', priority: 0, areaCodes: null },
  { name: 'ЮАР', iso2: 'za', dialCode: '27', priority: 0, areaCodes: null },
  { name: 'Южный Судан', iso2: 'ss', dialCode: '211', priority: 0, areaCodes: null },
  { name: 'Ямайка', iso2: 'jm', dialCode: '1876', priority: 0, areaCodes: null },
  { name: 'Япония', iso2: 'jp', dialCode: '81', priority: 0, areaCodes: null }
]
